import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, withModifiers as _withModifiers, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/svg/mp3Icon.svg'
import _imports_1 from '@/assets/imgcaptions/icon_fileXXXXL.svg'
import _imports_2 from '@/assets/aivoice/pic_kongyinpin.svg'


const _hoisted_1 = {
  key: 0,
  class: "tableTitle"
}
const _hoisted_2 = { class: "tableImg" }
const _hoisted_3 = {
  key: 1,
  class: "tableList"
}
const _hoisted_4 = { class: "tableOne" }
const _hoisted_5 = { class: "tableImg" }
const _hoisted_6 = ["onDblclick"]
const _hoisted_7 = ["src"]
const _hoisted_8 = ["onDblclick"]
const _hoisted_9 = { class: "tableName" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["onDblclick"]
const _hoisted_12 = ["onDblclick"]
const _hoisted_13 = ["onUpdate:modelValue", "onBlur"]
const _hoisted_14 = ["onUpdate:modelValue", "onBlur"]
const _hoisted_15 = { class: "tableOneRight" }
const _hoisted_16 = { class: "partner" }
const _hoisted_17 = {
  key: 0,
  class: "partnerBox"
}
const _hoisted_18 = ["src"]
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "timeRun" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { key: 2 }
const _hoisted_24 = {
  key: 0,
  class: "dataTimesLine"
}
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "runSize" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "captionsState" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { key: 2 }
const _hoisted_33 = {
  key: 3,
  class: "statTimeStyle"
}
const _hoisted_34 = { class: "timeUp" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { class: "operate" }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = ["onClick"]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = ["onClick"]
const _hoisted_42 = ["onClick"]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = ["onClick"]
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["onClick"]
const _hoisted_47 = ["onClick"]
const _hoisted_48 = {
  key: 2,
  class: "noDataPage"
}
const _hoisted_49 = {
  key: 0,
  class: "stripBoxmask"
}
const _hoisted_50 = { class: "stripdelBox" }

import { ref, onMounted, watch, getCurrentInstance, nextTick,onBeforeUnmount } from 'vue'
// 字节数长度
import { fileSizeNum } from '@/components/public-method/file-size'
// 时间处理方法
import { timeInfominute, timedata } from '@/components/public-method/time-method'
import { useRouter } from "vue-router";
import { ElMessage, ElMessageBox, ElLoading } from "element-plus";
// 接口
import newCaptionApi from "@/api/newCaption/index.ts";
import headPic from '@/assets/aivoice/ico_morentouxiang.svg';
// 引入删除提示
import delbox from "@/components/common/del.vue";
// 引入树形模块
import routTree from "./routTree.vue"
import { useUploadStore } from "@/store/uploadRate";
import FetchRequest from "@/api/FetchRequest";
import Auth from "@/api/Auth";
const multiple = 1

export default /*@__PURE__*/_defineComponent({
  __name: 'arrangeStrip',
  props: {
    size: Number,//放大倍数
    list: Array,
    justUse: Array,
    treeList:Array,//文件夹列表
},
  emits: ['del', 'reName', 'showopenFiled','runDataRun','reCatalog'],
  setup(__props, { expose: __expose, emit: __emit }) {

let { proxy } = getCurrentInstance()
const router = useRouter();
const token = Auth.getToken();
const uploadStore = useUploadStore();
// 删除提示弹窗
const opendelShow=ref(false)
const delText=ref('删除该项目，且永久不可恢复，确认删除？')
//默认宽度
const initStyle = {
    width: 11.3,
    height: 6.4
}
const overStyle = {
    background: 'rgba(30, 104, 201, 0.30)'
}
// 字幕状态
const textTypeList=[
    {
        subtitleType:0,
        text:'等待处理中'
    },
    {
        subtitleType:1,
        text:'音视频上传中'
    },
    {
        subtitleType:-1,
        text:'音视频上传失败'
    },
    {
        subtitleType:2,
        text:'音视频转码中'
    },
    {
        subtitleType:-2,
        text:'音视频转码失败'
    },
    {
        subtitleType:3,
        text:'AI识别字幕中'
    },
    {
        subtitleType:30,
        text:'等待AI识别字幕'
    },
    {
        subtitleType:-3,
        text:'AI识别字幕失败'
    },
    {
        subtitleType:-4,
        text:'SRT解码错误'
    },
    {
        subtitleType:100,
        text:'AI识别完成'
    },
]

const initmultiple = ref(1)//初始倍数
const amplify = ref(1) //放大倍数
const props = __props
const dataList = ref([])
// 打开字幕编辑页面
const projectoften = ref([])
const stateList=ref([])
let timers
onMounted(() => {
    console.log('列表数据')
    // console.log(props.treeList)
    // console.log(props.list)
    dataList.value = JSON.parse(JSON.stringify(props.list))
    if (props.size > 0) {
        amplify.value = (props.size / 30)
        initmultiple.value = (multiple + amplify.value)
    }
    projectoften.value = JSON.parse(localStorage.getItem('projectoften')) || []
    stateList.value=[]
    abortStream()
    dataList.value.forEach(item=>{
        if(item.subtitleStatus==2){
            stateList.value.push(item.subtitleId)
        }

    })
    clearInterval(timers)
    timers=null
    let len=dataList.value.findIndex(it=>it.recognizeRemainingTime*1>0)
    console.log('============'+len)
    if(len>-1){
        timers = setInterval(() => {
            dataList.value.forEach( item =>{
                    if(item.recognizeRemainingTime*1 > 1){
                        console.log('============'+item.recognizeRemainingTime)
                        item.recognizeRemainingTime=item.recognizeRemainingTime*1
                        item.recognizeRemainingTime-=1
                    }
                })
            },1000)
    }
    nextTick(()=>{
        stateData()
    })
})
watch(() => props.list, (n, o) => {
    // console.log('动态获取文件')
    abortStream()
    stateList.value=[]
    dataList.value = JSON.parse(JSON.stringify(props.list))
    dataList.value.forEach(item=>{
        if(item.subtitleStatus==2){
            stateList.value.push(item.subtitleId)
        }

    })
    nextTick(()=>{
        // console.log(stateList.value)
        console.log('动态获取文件')
        abortStream()
        if(stateList.value.length>0){

            stateData()
        }
        
    })
    clearInterval(timers)
    timers=null
    let len=dataList.value.findIndex(it=>it.recognizeRemainingTime*1>-1)
    console.log('============'+len)
    if(len>-1){
        timers = setInterval(() => {
            dataList.value.forEach( item =>{
                if(item.recognizeRemainingTime*1 > 1){
                    console.log('============'+len)
                    item.recognizeRemainingTime=item.recognizeRemainingTime*1
                    item.recognizeRemainingTime-=1
                }
            })
        },1000)
    }
   
})
// 动态获取文件处理状态
let reader = null;
let abortController = null;
const showStateList=ref([])
const stateData = async () => {
    // console.log('=======================')
    abortController= new AbortController();
  try {
    const response = await fetch(FetchRequest.getHost() + '/ai/subtitle/sse/progress', {
      method: 'POST',
      headers: {
         'Content-Type': 'application/json' ,
         Authorization: "Bearer " + token,
        },
      body:  JSON.stringify( stateList.value ) ,
      signal: abortController.signal
    });
    
    // 验证响应类型
    if (!response.ok || !response.body) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
     // 创建流处理器
     reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';
    const CHUNK_SIZE = 500; // 每积累500字符更新一次
    let initNum=0
    let partialLine = '';
    let chunk=''
    // 使用异步循环读取数据
    while (initNum<CHUNK_SIZE) {
      const { done, value } = await reader.read();
      console.log(value)
      if(value==undefined&&stateList.value.length>0){
        setTimeout(()=>{
            abortStream()
            stateData()
        },1000)
        
      }
    //   console.log(done)
      // 流结束处理
      if (done) {
        // 处理最后缓冲区的剩余数据
        if (buffer.length > 0) {
        //   streamText.value += buffer;
          console.log(buffer)
          buffer = '';
        }
        break;
      }

      // 解码并缓冲数据
      
      // 分块更新优化（减少响应式更新频率）
      chunk=decoder.decode(value, { stream: true });
      console.log(chunk)
      let lines=''
      if(chunk.endsWith('data:') ||chunk.startsWith('[')){
        console.log(chunk)
        // console.log('======++++======')
        partialLine+=chunk
      } else{
        // console.log('============')
        // console.log(partialLine+ chunk)
        lines = (partialLine+ chunk).split('\n')
        partialLine=''
      }
      console.log(lines)
      
  
      for (const line of lines) {
          if (line.trim() === '') continue;
          const data = line.replace('data:', '').trim();
            //   console.log(JSON.parse(data))
          if (line.startsWith('data:')) {
              const data = line.replace('data:', '').trim();
              console.log(JSON.parse(data))
            //   let init=JSON.parse(data)
            // showStateList.value=JSON.parse(data)
            showStateList.value=(JSON.parse(data)).filter(it=>it.remainingTime!=undefined  &&it.remainingTime>0)
              console.log( showStateList.value)
            
          }
      }


    }
  }
   catch (error) {
    console.error('流式请求失败:', error);
  } finally {
    abortController = null;
  }
  
};

// 手动终止流
const abortStream = () => {
  if (abortController) {
    abortController.abort();
    abortController = null
    // streamText.value = '';
  }
};

// 组件卸载时自动终止
onBeforeUnmount(abortStream);
watch(() => props.size, (n, o) => {
    console.log('放大倍数' + n)
    amplify.value = (n / 30)
    initmultiple.value = (multiple + amplify.value)
    console.log(initmultiple.value * initStyle.width)

})
watch(() => props.list.length, (n, o) => {
    dataList.value = JSON.parse(JSON.stringify(props.list))
})
watch(() => props.justUse, (n, o) => {
    projectoften.value = JSON.parse(localStorage.getItem('projectoften')) || []
})
const emit = __emit
// 查看文件夹
const openFiled = (item: any) => {
    console.log(item)
    emit('showopenFiled', JSON.stringify(item))
}
const reState=(subtitleId,subtitleStatus)=>{
    console.log(subtitleId)
    console.log(subtitleStatus)
    if(subtitleStatus==3){
        let index=stateList.value.indexOf(subtitleId)
        if(index>-1){
            stateList.value.splice(index,1)
            console.log(stateList.value)
            if(stateList.value.length>0){
                abortStream()
                setTimeout(()=>{
                    stateData()
                },500)
                
            }else{
                console.log('======结束流==========')
                abortStream()
            }
        }
    }
    dataList.value.filter(item=>item.subtitleId==subtitleId)[0].subtitleStatus=subtitleStatus
}
// 重新识别
const reRunData=(data:any)=>{
    console.log(data)
    emit('runDataRun', data.subtitleId)
    // runDataRun
}
// 更改目录
const treeListShow=ref(-1)
const treeListStyle=ref({
    top:'2rem',
    left:'-3rem'
})
const subtitleId=ref('')
const editCatalog=(data:any,index:number)=>{
    console.log(data)
    subtitleId.value=data.subtitleId
    treeListShow.value=index
    // emit('reCatalog')
}
 const showParentRout=(data:any)=>{
        console.log(data)
        newCaptionApi.putInitOneCatalog(subtitleId.value,data[1]).then(res=>{
            console.log(res)
            treeListShow.value=-1
            emit('reCatalog')
        })
        // emit('reCatalog')
}
// 更改目录

// 删除
const delData=ref()
const delIndex=ref(0)
const delThis = (data: object, index: number) => {
    console.log(data)
    if(data.folderName!=undefined){
        delText.value="删除该目录将会删除目录下所有文件以及目录，且永久不可恢复，确认删除？"
    }else{
        delText.value="删除该项目，且永久不可恢复，确认删除？"
    }
    delData.value=data
    delIndex.value=index
    opendelShow.value=true
    // emit('del', [data, index])
}
const recognition=()=>{
    opendelShow.value=false
    emit('del', [delData.value, delIndex.value])
}
// 重命名
const editName = (data: object, index: number) => {
    if(data.type==0){
        console.log('文件')
        const haveName=props.list.filter(item=>(item.type==0 && item.title==data.title))
        if(haveName.length>1){
            dataList.value[index].title=oldName.value
            ElMessage.warning("文件名称重复!")
            return
        }
    }else{
        const haveName=props.list.filter(item=>(item.type==1 && item.folderName==data.folderName))
        if(haveName.length>1){
            dataList.value[index].folderName=oldName.value
            ElMessage.warning("文件夹名称重复!")
            return
        }
    }
    editIndex.value = -1
    emit('reName', [data, index])
}

onMounted(() => {
  document.addEventListener("click", (event) => {
    editIndex.value = -1
    treeListShow.value= -1
  });
});
const closeAll=()=>{
    editIndex.value = -1
    treeListShow.value= -1
}
// 删除文件
const delOne = (subtitleId: string) => {
    newCaptionApi.delText(subtitleId).tnen((res) => {
        console.log(res)
    })
}
// 删除文件夹
const delFolderOne = (id: string) => {
    newCaptionApi.delFolder(id).tnen((res) => {
        console.log(res)
    })
}
// 文件重命名
const editIndex = ref(-1)
const oldName=ref('')
const editIndexfun = (index: number,data:any) => {
    editIndex.value = index
    if(data.type==0){
        oldName.value=data.title
    }else{
        oldName.value=data.folderName
    }
}
const editOne = (id: string, parentId: number, title: string) => {
    newCaptionApi.putOne(id, parentId, title).then((res) => {
        console.log(res)
    })
}
// 文件夹重命名
const editFolderOne = (id: string, parentId: number, folderName: string) => {
    newCaptionApi.putFolderOne(id, parentId, folderName).then((res) => {
        console.log(res)
    })
}
const subtitleStateList = ref([
    { value: 0, text: '等待处理 ' },
    { value: 1, text: '音视频转码中 ' },
    { value: -1, text: '音视频转码中 ' },
    { value: 2, text: '音视频转码中 ' },
    { value: -2, text: '音视频转码失败 ' },
    { value: 30, text: 'AI识别字幕 ' },
    { value: 3, text: 'AI识别字幕中 ' },
    { value: -3, text: 'AI识别字幕失败 ' },
    { value: -4, text: 'SRT解码错误 ' },
    { value: 100, text: '完成初始化 ' },
])
//  0.等待处理 1.音视频转码中 -1.转码失败 9.无字幕 10.人工字幕  20.AI字幕识别中 21.AI字幕 -20.识别失败

const openEdit = (data: any) => {
    console.log('存储页面常编辑视频')
    console.log(data)
    if(data.subtitleStatus==-3  || data.subtitleStatus!=100){
        return
    }
    // 存储页面常编辑视频
    if (projectoften.value.length != 0) {
        const oftennum = projectoften.value.filter(item => item.subtitleId == data.subtitleId)
        console.log(oftennum)
        if (projectoften.value.length < 10 && oftennum.length == 0) {
            projectoften.value.unshift(data)
            localStorage.setItem('projectoften', JSON.stringify(projectoften.value))
        } else if (projectoften.value.length == 10) {
            projectoften.value.unshift(data)
            projectoften.value.pop()
            localStorage.setItem('projectoften', JSON.stringify(projectoften.value))
        }
    } else {
        projectoften.value.push(data)
        localStorage.setItem('projectoften', JSON.stringify(projectoften.value))
    }
    nextTick(() => {
        router.push({ path: '/index/aiApply/captionsEdit', query: { subtitleId: data.subtitleId } })
    })

    // 
}
// 接受邀请
const okShare = (subtitleId: string) => {
    newCaptionApi.sharePut(subtitleId).then((res) => {
        console.log(res)
        // shareStatus
        dataList.value.filter(item => item.subtitleId == subtitleId)[0].shareStatus = '1'
    })
}
const onShare = (subtitleId: string, index: number) => {
    newCaptionApi.cancelsharePut(subtitleId).then((res) => {
        console.log(res)
        dataList.value.splice(index, 1)
    })
}
__expose({
    reState,
})

return (_ctx: any,_cache: any) => {
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", {
    class: "stripBoxStyle",
    onClick: _withModifiers(closeAll, ["stop"])
  }, [
    (dataList.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: "tableImgTitle",
              style: _normalizeStyle({ width: initmultiple.value * initStyle.width + 'rem' })
            }, " 音视频 ", 4)
          ]),
          _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"tableName\" data-v-361e0cd6>名称</div><div class=\"tableTitleRight\" data-v-361e0cd6><div class=\"partner\" data-v-361e0cd6>协同</div><div class=\"timeRun\" data-v-361e0cd6>时长</div><div class=\"runSize\" data-v-361e0cd6>大小</div><div class=\"captionsState\" data-v-361e0cd6>状态</div><div class=\"timeUp\" data-v-361e0cd6>上传时间</div><div class=\"operate\" data-v-361e0cd6>操作</div></div>", 2))
        ]))
      : _createCommentVNode("", true),
    (dataList.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_el_scrollbar, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataList.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "tableOneBox",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      (item.type == 0)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "tableImgOnly",
                            onDblclick: _withModifiers(($event: any) => (openEdit(item)), ["stop"])
                          }, [
                            (item.snapshot != undefined)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: _unref(proxy).getimgUrl + '/' + item.snapshot,
                                  alt: "",
                                  style: _normalizeStyle({ width: initmultiple.value * initStyle.width + 'rem', height: initmultiple.value * initStyle.height + 'rem' })
                                }, null, 12, _hoisted_7))
                              : _createCommentVNode("", true),
                            (item.snapshot == undefined)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  style: _normalizeStyle({ width: initmultiple.value * initStyle.width + 'rem', height: initmultiple.value * initStyle.height + 'rem', padding: '2rem 3rem', })
                                }, _cache[6] || (_cache[6] = [
                                  _createElementVNode("img", {
                                    src: _imports_0,
                                    style: {"width":"100%","height":"100%"}
                                  }, null, -1)
                                ]), 4))
                              : _createCommentVNode("", true)
                          ], 40, _hoisted_6))
                        : _createCommentVNode("", true),
                      (item.type == 1)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "tableImgFolder",
                            onDblclick: _withModifiers(($event: any) => (openFiled(item)), ["stop"])
                          }, [
                            _createElementVNode("img", {
                              src: _imports_1,
                              style: _normalizeStyle({ width: initmultiple.value * initStyle.width + 'rem', height: initmultiple.value * initStyle.height + 'rem' })
                            }, null, 4)
                          ], 40, _hoisted_8))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      (index != editIndex.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                            (item.type == 0)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  onDblclick: _withModifiers(($event: any) => (openEdit(item)), ["stop"])
                                }, _toDisplayString(item.title), 41, _hoisted_11))
                              : _createCommentVNode("", true),
                            (item.type == 1)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 1,
                                  onDblclick: _withModifiers(($event: any) => (openFiled(item)), ["stop"])
                                }, _toDisplayString(item.folderName), 41, _hoisted_12))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (index == editIndex.value && item.type == 0)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "tableNameInput",
                            onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": ($event: any) => ((item.title) = $event),
                              onBlur: ($event: any) => (editName(item, index)),
                              maxlength: "100",
                              "show-word-limit": ""
                            }, null, 40, _hoisted_13), [
                              [_vModelText, item.title]
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (index == editIndex.value && item.type == 1)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            class: "tableNameInput",
                            onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": ($event: any) => ((item.folderName) = $event),
                              onBlur: ($event: any) => (editName(item, index)),
                              maxlength: "100",
                              "show-word-limit": ""
                            }, null, 40, _hoisted_14), [
                              [_vModelText, item.folderName]
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        (item.shareUsers != undefined)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.shareUsers, (it, itindex) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: itindex,
                                  class: "partnerList"
                                }, [
                                  (it.avatar != undefined&&it.avatar != ''&&it.share)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: _unref(proxy).getimgUrl+ it.avatar,
                                        alt: ""
                                      }, null, 8, _hoisted_18))
                                    : _createCommentVNode("", true),
                                  ((it.avatar == undefined || it.avatar == '')&&it.share)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 1,
                                        src: _unref(headPic),
                                        alt: ""
                                      }, null, 8, _hoisted_19))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        (item.duration != undefined )
                          ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_unref(timeInfominute)(item.duration )), 1))
                          : _createCommentVNode("", true),
                        (item.duration == undefined && item.type == 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_22, "--"))
                          : _createCommentVNode("", true),
                        (item.duration == undefined && item.type != 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(uploadStore).uploadTasks, ([taskId, task]) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: taskId,
                                  class: "progress-item"
                                }, [
                                  (taskId==item.subtitleId)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                        _createElementVNode("div", {
                                          class: "dataTimesBar",
                                          style: _normalizeStyle({'width':task.progress+'%'})
                                        }, null, 4)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (taskId==item.subtitleId)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_unref(fileSizeNum)(task.bytes)), 1))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        (item.type == 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_unref(fileSizeNum)(item.fileSize)), 1))
                          : _createCommentVNode("", true),
                        (item.type == 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_28, " -- "))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        (item.type != 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(textTypeList.filter(it=>it.subtitleType==item.subtitleStatus)[0].text), 1))
                          : _createCommentVNode("", true),
                        (item.type == 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_31, "--"))
                          : _createCommentVNode("", true),
                        (item.subtitleStatus==3&&item.recognizeRemainingTime!=undefined)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_unref(timeInfominute)(item.recognizeRemainingTime*1000)), 1))
                          : _createCommentVNode("", true),
                        (showStateList.value .length>0&&item.subtitleStatus==2 &&showStateList.value.filter(it=>it.subtitleId != undefined &&it.subtitleId==item.subtitleId)[0]!=undefined)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_unref(timeInfominute)((showStateList.value.filter(it=>it.subtitleId != undefined &&it.subtitleId==item.subtitleId)[0].remainingTime)*1000)), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        (item.createTime != undefined)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_unref(timedata)(item.createTime)), 1))
                          : _createCommentVNode("", true),
                        (item.createTime == undefined)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_36, "--"))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        (item.isMine)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              onClick: _withModifiers(($event: any) => (delThis(item, index)), ["stop"])
                            }, "删除", 8, _hoisted_38))
                          : _createCommentVNode("", true),
                        (item.type == 0 && item.isMine&&item.subtitleStatus!=-3 &&item.subtitleStatus==100)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              onClick: _withModifiers(($event: any) => (openEdit(item)), ["stop"])
                            }, "编辑", 8, _hoisted_39))
                          : _createCommentVNode("", true),
                        (item.type == 1 && item.isMine)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 2,
                              onClick: _withModifiers(($event: any) => (openFiled(item)), ["stop"])
                            }, "查看文件夹", 8, _hoisted_40))
                          : _createCommentVNode("", true),
                        (!item.isMine && item.shareStatus == 1&&item.subtitleStatus!=-3 &&item.subtitleStatus==100)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 3,
                              onClick: _withModifiers(($event: any) => (openEdit(item)), ["stop"])
                            }, "编辑", 8, _hoisted_41))
                          : _createCommentVNode("", true),
                        (item.type == 0 &&item.isMine&&item.subtitleStatus!=-3)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 4,
                              onClick: _withModifiers(($event: any) => (editIndexfun(index,item)), ["stop"])
                            }, "重命名", 8, _hoisted_42))
                          : _createCommentVNode("", true),
                        (item.type == 1 &&item.isMine&&item.subtitleStatus!=-3)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 5,
                              onClick: _withModifiers(($event: any) => (editIndexfun(index,item)), ["stop"])
                            }, "重命名", 8, _hoisted_43))
                          : _createCommentVNode("", true),
                        (!item.isMine && item.shareStatus == 0)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 6,
                              onClick: _withModifiers(($event: any) => (okShare(item.subtitleId)), ["stop"])
                            }, "接受邀请", 8, _hoisted_44))
                          : _createCommentVNode("", true),
                        (!item.isMine && item.shareStatus == 0)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 7,
                              onClick: _withModifiers(($event: any) => (onShare(item.subtitleId, index)), ["stop"])
                            }, "拒绝邀请", 8, _hoisted_45))
                          : _createCommentVNode("", true),
                        (item.type == 0 &&item.isMine&&item.subtitleStatus==-3)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 8,
                              onClick: _withModifiers(($event: any) => (reRunData(item)), ["stop"])
                            }, "AI字幕重新识别", 8, _hoisted_46))
                          : _createCommentVNode("", true),
                        (item.type == 0 &&item.isMine)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 9,
                              onClick: _withModifiers(($event: any) => (editCatalog(item,index)), ["stop"])
                            }, "更改目录", 8, _hoisted_47))
                          : _createCommentVNode("", true),
                        (treeListShow.value==index)
                          ? (_openBlock(), _createBlock(routTree, {
                              key: 10,
                              data: props.treeList,
                              class: "routTree",
                              onUpparentId: showParentRout,
                              onCloseThis: _cache[2] || (_cache[2] = ($event: any) => (treeListShow.value = -1)),
                              onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
                              style: _normalizeStyle(treeListShow.value==index?treeListStyle.value:'')
                            }, null, 8, ["data", "style"]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (dataList.value.length == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_48, _cache[7] || (_cache[7] = [
          _createElementVNode("div", { class: "imgBox" }, [
            _createElementVNode("img", { src: _imports_2 }),
            _createElementVNode("div", null, "暂无数据")
          ], -1)
        ])))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      (opendelShow.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, [
              _createVNode(delbox, {
                text: delText.value,
                onCloseThis: _cache[4] || (_cache[4] = ($event: any) => (opendelShow.value = false)),
                onRecognition: recognition
              }, null, 8, ["text"])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})